import "@fontsource/ibm-plex-sans-arabic/arabic-400.css";
import "@fontsource/ibm-plex-sans-arabic/arabic-600.css";
import "@fontsource/ibm-plex-sans-arabic/arabic-700.css";
import { setDefaultFontLoading } from "@ui5/webcomponents-base/dist/config/Fonts.js";

import font72Bold from "@sap-theming/theming-base-content/content/Base/baseLib/baseTheme/fonts/72-Bold.woff2?url";
import font72Regular from "@sap-theming/theming-base-content/content/Base/baseLib/baseTheme/fonts/72-Regular.woff2?url";
import font72Semibold from "@sap-theming/theming-base-content/content/Base/baseLib/baseTheme/fonts/72-Semibold.woff2?url";

/**
 * Self-hosted fonts (ADR-0009/D-7): SAP 72 (Apache-2.0) for Latin and IBM Plex Sans Arabic (OFL-1.1) for Arabic,
 * bundled from npm packages. UI5's default font loading from the SAP CDN is switched off.
 */
export function registerFonts(): void {
  setDefaultFontLoading(false);
  if (typeof FontFace === "undefined") {
    return;
  }

  const faces: [string, string][] = [
    [font72Regular, "400"],
    [font72Semibold, "600"],
    [font72Bold, "700"],
  ];
  for (const [url, weight] of faces) {
    const face = new FontFace("72", `url(${url}) format("woff2")`, { weight, style: "normal", display: "swap" });
    document.fonts.add(face);
  }
}
